import {ValidatorFn} from "@angular/forms";

export class FieldDefinition<T> {
  // Value of field
  value: T;
  // Key in final form
  key: string;
  // Displayed label
  label: string;
  // Info message to display
  info: string;
  // Warn message to display
  warn: string;
  // Required field
  required: boolean;
  // Field placeholder
  placeholder: string;
  // Field disabled
  disabled: boolean;
  // Field order in form
  order: number;
  // Full width field
  fullsize: boolean;
  // Type of field
  type: string;
  // Multiple value
  multiple: boolean;
  // Options listing
  options: ({ key: string, value: T }[] | any[]);
  // Custom validators
  validators: ValidatorFn[];
  // Payload to send in form
  payload: any;

  constructor(options: {
    value?: T;
    key?: string;
    label?: string;
    info?: string;
    warn?: string;
    required?: boolean;
    placeholder?: string;
    disabled?: boolean;
    order?: number;
    fullsize?: boolean;
    type?: string;
    multiple?: boolean;
    options?: ({ key: string, value: T }[] | any[]);
    validators?: ValidatorFn[];
    payload?: any;
  } = {}) {
    // @ts-ignore
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.info = options.info || '';
    this.warn = options.warn || '';
    this.placeholder = options.placeholder || '';
    this.required = !!options.required;
    this.disabled = !!options.disabled;
    this.order = options.order === undefined ? 1 : options.order;
    this.fullsize = options.fullsize === undefined ? true : options.fullsize;
    this.type = options.type || '';
    this.multiple = options.multiple || false;
    this.options = options.options || [];
    this.validators = options.validators || [];
    this.payload = options.payload;
  }
}
